import {
  blue,
  brown,
  common,
  green,
  grey,
  lime,
  maroon,
  navy,
  olive,
  orange,
  pink,
  purple,
  red,
  teal,
  turquoise,
  violet,
  yellow,
} from '../../colors';
import { createMuiBackdrop } from '../../utils';

const palette = {
  background: {
    default: common.light,
    paper: common.white,
    backdrop: createMuiBackdrop(grey[200]),
  },
  primary: {
    main: blue[100],
    dark: blue[120],
    darkest: blue[140],
    light: blue[80],
    lightest: blue[20],
    lighter: blue[40],
    faint: blue[10],
    contrastText: common.white,
  },
  secondary: {
    main: grey[200],
    dark: common.black,
    darkest: grey[200],
    light: grey[60],
    lightest: grey[10],
    lighter: grey[40],
    faint: grey[10],
    contrastText: common.white,
  },
  error: {
    main: red[100],
    dark: red[120],
    darkest: red[140],
    light: red[80],
    lightest: red[20],
    lighter: red[40],
    faint: red[10],
    contrastText: common.white,
  },
  warning: {
    main: yellow[100],
    dark: yellow[120],
    darkest: yellow[140],
    light: yellow[80],
    lightest: yellow[20],
    lighter: yellow[40],
    faint: yellow[10],
    contrastText: common.dark,
  },
  info: {
    main: navy[100],
    dark: navy[120],
    darkest: navy[140],
    light: navy[80],
    lightest: navy[20],
    lighter: navy[40],
    faint: navy[10],
    contrastText: common.dark,
  },
  success: {
    main: green[100],
    dark: green[120],
    darkest: green[140],
    light: green[80],
    lightest: green[20],
    lighter: green[40],
    faint: green[10],
    contrastText: common.dark,
  },
  green: {
    main: green[100],
    dark: green[120],
    darkest: green[140],
    light: green[80],
    lightest: green[20],
    lighter: green[40],
    faint: green[10],
    contrastText: common.dark,
  },
  yellow: {
    main: yellow[100],
    dark: yellow[120],
    darkest: yellow[140],
    light: yellow[80],
    lightest: yellow[20],
    lighter: yellow[40],
    faint: yellow[10],
    contrastText: common.dark,
  },
  red: {
    main: red[100],
    dark: red[120],
    darkest: red[140],
    light: red[80],
    lightest: red[20],
    lighter: red[40],
    faint: red[10],
    contrastText: common.white,
  },
  blue: {
    main: blue[100],
    dark: blue[120],
    darkest: blue[140],
    light: blue[80],
    lightest: blue[20],
    lighter: blue[40],
    faint: blue[10],
    contrastText: common.white,
  },
  teal: {
    main: teal[100],
    dark: teal[120],
    darkest: teal[140],
    light: teal[80],
    lightest: teal[20],
    lighter: teal[40],
    faint: teal[10],
    contrastText: common.dark,
  },
  pink: {
    main: pink[100],
    dark: pink[120],
    darkest: pink[140],
    light: pink[80],
    lightest: pink[20],
    lighter: pink[40],
    faint: pink[10],
    contrastText: common.white,
  },
  purple: {
    main: purple[100],
    dark: purple[120],
    darkest: purple[140],
    light: purple[80],
    lightest: purple[20],
    lighter: purple[40],
    faint: purple[10],
    contrastText: common.white,
  },
  brown: {
    main: brown[100],
    dark: brown[120],
    darkest: brown[140],
    light: brown[80],
    lightest: brown[20],
    lighter: brown[40],
    faint: brown[10],
    contrastText: common.white,
  },
  orange: {
    main: orange[100],
    dark: orange[120],
    darkest: orange[140],
    light: orange[80],
    lightest: orange[20],
    lighter: orange[40],
    faint: orange[10],
    contrastText: common.dark,
  },
  lime: {
    main: lime[100],
    dark: lime[120],
    darkest: lime[140],
    light: lime[80],
    lightest: lime[20],
    lighter: lime[40],
    faint: lime[10],
    contrastText: common.dark,
  },
  navy: {
    main: navy[100],
    dark: navy[120],
    darkest: navy[140],
    light: navy[80],
    lightest: navy[20],
    lighter: navy[40],
    faint: navy[10],
    contrastText: common.dark,
  },
  violet: {
    main: violet[100],
    dark: violet[120],
    darkest: violet[140],
    light: violet[80],
    lightest: violet[20],
    lighter: violet[40],
    faint: violet[10],
    contrastText: common.white,
  },
  maroon: {
    main: maroon[100],
    dark: maroon[120],
    darkest: maroon[140],
    light: maroon[80],
    lightest: maroon[20],
    lighter: maroon[40],
    faint: maroon[10],
    contrastText: common.white,
  },
  turquoise: {
    main: turquoise[100],
    dark: turquoise[120],
    darkest: turquoise[140],
    light: turquoise[80],
    lightest: turquoise[20],
    lighter: turquoise[40],
    faint: turquoise[10],
    contrastText: common.dark,
  },
  olive: {
    main: olive[100],
    dark: olive[120],
    darkest: olive[140],
    light: olive[80],
    lightest: olive[20],
    lighter: olive[40],
    faint: olive[10],
    contrastText: common.dark,
  },
  black: {
    main: grey[160],
    dark: grey[180],
    darkest: grey[200],
    light: grey[60],
    lightest: grey[40],
    lighter: grey[20],
    faint: grey[10],
    contrastText: common.white,
  },
  text: {
    header: grey[200],
    primary: grey[180],
    secondary: grey[160],
    disabled: grey[120],
  },
  action: {
    hover: blue[20],
  },
  divider: grey[60],
};

export default palette;
